<template>
  <div>
    <staff-form v-model="staff"></staff-form>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      staff: {
        first_name: '',
        last_name: '',
        email: '',
        password: ''
      }
    };
  },
  mounted: function () {
    this.setBreadcrumbs([
      { to: { name: 'staffs' }, text: 'Staff accounts' },
      { to: { name: 'staff-crate' }, text: 'New staff account' }
    ]);
  }
};
</script>
